<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pXxOHZ/tc-custom/9781398486843.jpg?1726274072006" alt="This image is the cover for the book The Girl Who Dressed like a Boy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Girl Who Dressed like a Boy
      </h1>
      <p class="bookDescription body article font2">
        <p>This story takes place long ago, in a time when the Celts were under threat from all sides. The Saxons, the Welsh, and the Irish all want to settle in the rich land of Briton. The Romans have left, leaving the Celts to fend for themselves. The land is divided into kingdoms, with each king jealously guarding his borders. Only the strong stand, the weak fall. An old warrior and a young woman are all that are left of their village after a Saxon raid. They embark on a journey to find help and a new home. King Arthur, in the south, needs to be made aware of what is happening in the far reaches of his kingdom. The world is not a safe place for a young girl, innocent of the ways of men. She soon finds herself being used as a pawn in a game between kings. Her sexual awakening comes at a price, as does her life. She finds that in order to survive, she has to learn many new skills.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jan Hale
      </h2>
      
      <p class="authorDescription body article">Jan lives in Orpington, Kent, with her partner, Austin, and her rescue dog, Fleur. An avid reader, she has been inspired by a wide range of authors over the years and has now crafted her own novel. The Girl Who Dressed Like a Boy is to be the first of a trilogy.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8ecb6076